// src/redux/userSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getUsersById } from '../services/userService';

const loadInitialState = () => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  return {
    user: user ? JSON.parse(user) : null,
    token: token || null,
  };
};

const userSlice = createSlice({
  name: 'user',
  initialState: loadInitialState(),
  reducers: {
    loginUser: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logoutUser: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

export const { loginUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;